__turbopack_context__.v({
  "eventInfo": "aMrS5q_eventInfo",
  "eventInfoContent": "aMrS5q_eventInfoContent",
  "eventInfoRaw": "aMrS5q_eventInfoRaw",
  "eventRow": "aMrS5q_eventRow",
  "eventRowButton": "aMrS5q_eventRowButton",
  "grid": "aMrS5q_grid",
  "listenerText": "aMrS5q_listenerText",
  "spinner": "aMrS5q_spinner",
});
